import Component from '../core/Component'
import { queryAll } from '../utils/dom'

const STATES = {
    OPEN: 'is-open'
}

export default class PortfolioTable extends Component {
    constructor(element, options = {}) {
        super(element, options)
    
        this.ref = {
            opener: null            
        }
    }

    prepare() {
        if (!this.ref.opener) {
            return
        }

        this.ref.opener.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault()
        this.element.classList.add(STATES.OPEN)

        const fixedTables = queryAll('[data-component="FixedTable"]')
        fixedTables.forEach(fixedTableEl => {
            const fixedTable = Component.getFromElement(fixedTableEl)
            if (!fixedTable) {
                return
            }
            fixedTable.resize()
        })
    }
}


// WEBPACK FOOTER //
// ./components/PortfolioTable.js